import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import styled from 'styled-components';
import { space } from 'styled-system';

import EventListMapper from './Mapper';
import { isAfter, isBefore, endOfDay } from 'date-fns';
import Input from '../../Input';

const now = new Date();

const StyledTab = styled(Tab)`
  ${space}
  cursor: pointer;
  color: ${({ theme }) => theme.color.secondary};
  &.react-tabs__tab--selected {
    transition: 0.3s ease;
    color: ${({ theme }) => theme.colors.valhalla};
  }
`;

const EventList = ({ events }) => {
  const [filter, onChangeFilter] = useState('');
  const upcomingEvents = events.filter(event =>
    isAfter(new Date(event.start_date), now),
  );
  const pastEvents = events.filter(event =>
    isBefore(endOfDay(new Date(event.end_date)), now),
  );
  return (
    <Tabs>
      <TabList>
        <Flex
          p={2}
          flexWrap="wrap"
          flexDirection={['column-reverse', 'row']}
          alignItems="center"
          justifyContent="space-between"
          m={-2}
        >
          <Flex
            p={2}
            width={[1, 'auto']}
            alignItems="center"
            justifyContent={['center', 'flex-start']}
            mx={-3}
          >
            <StyledTab px={3}>Upcoming ({upcomingEvents.length})</StyledTab>
            <StyledTab px={3}>Past ({pastEvents.length})</StyledTab>
          </Flex>
          <Input
            m={2}
            width={[1, 'auto']}
            lineHeight={['14px', '16px']}
            value={filter}
            onChange={e => onChangeFilter(e.target.value)}
            placeholder="🔎 Find events by location"
            style={{
              minWidth: '240px',
            }}
          />
        </Flex>
      </TabList>
      <TabPanel>
        <EventListMapper filter={filter} events={upcomingEvents} />
      </TabPanel>
      <TabPanel>
        <EventListMapper filter={filter} events={pastEvents} />
      </TabPanel>
    </Tabs>
  );
};

EventList.propTypes = {
  campusEvents: PropTypes.bool,
};

EventList.defaultProps = {
  campusEvents: false,
};

export default EventList;
